(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ed-newsletter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ed-newsletter')) {
 customElements.define('ed-newsletter', class extends HTMLElement {
  connectedCallback() {
   this.controller = new AbortController();
   const options = {signal: this.controller.signal};
   this.dialog = this.querySelector('dialog');
   if (!this.dialog) return;
   const remember = () => { try { localStorage.setItem('ed-newsletter-dismissed', String(Date.now())); } catch {} };
   this.querySelectorAll('[data-signup-open]').forEach(button => button.addEventListener('click', () => this.dialog.showModal(), options));
   this.querySelectorAll('[data-signup-close]').forEach(button => button.addEventListener('click', () => { this.dialog.close(); remember(); }, options));
   this.dialog.addEventListener('cancel', remember, options);
   this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) { this.dialog.close(); remember(); } } }, options);
   if (this.querySelector('[data-signup-success]')) { remember(); if (location.hash.includes('EdPopup-')) this.dialog.showModal(); return; }
   let dismissed = 0; try { dismissed = Number(localStorage.getItem('ed-newsletter-dismissed')) || 0; } catch {}
   if (!this.hasAttribute('data-design-mode') && Date.now() - dismissed > 7 * 86400000) {
    this.timer = setTimeout(() => { if (this.isConnected && !document.querySelector('dialog[open]') && !document.hidden) this.dialog.showModal(); }, Number(this.dataset.delay) || 12000);
   }
  }
  disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ed-recently-viewed"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ed-recently-viewed')) {
 customElements.define('ed-recently-viewed', class extends HTMLElement {
  async connectedCallback() {
   this.controller = new AbortController();
   const key = 'ed-recent-products';
   let handles = [];
   try { const data = JSON.parse(localStorage.getItem(key) || '[]'); if (Array.isArray(data)) handles = data.filter(x => typeof x === 'string' && /^[a-z0-9-]+$/.test(x)).slice(0, 12); } catch {}
   const current = this.dataset.current;
   if (current) { try { localStorage.setItem(key, JSON.stringify([current, ...handles.filter(x => x !== current)].slice(0, 12))); } catch {} }
   const selected = handles.filter(x => x !== current).slice(0, Number(this.dataset.limit) || 4);
   const products = await Promise.all(selected.map(async handle => { try { const response = await fetch(`${this.dataset.root}products/${encodeURIComponent(handle)}.js`, {signal:this.controller.signal}); return response.ok ? await response.json() : null; } catch { return null; } }));
   if (!this.isConnected) return;
   const grid = this.querySelector('.ed-recent-grid');
   for (const product of products.filter(Boolean)) {
    const a = document.createElement('a'); a.href = `${this.dataset.root}products/${encodeURIComponent(product.handle)}`; a.className = 'ed-recent-card';
    if (product.featured_image) { const image = document.createElement('img'); image.src = product.featured_image; image.alt = product.title; image.loading = 'lazy'; image.width = 600; image.height = 750; a.append(image); }
    const title = document.createElement('h3'); title.textContent = product.title; a.append(title);
    const price = document.createElement('p'); let formatted; try { formatted = new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:this.dataset.currency}).format(product.price/100); } catch { formatted = `${this.dataset.currency} ${(product.price/100).toFixed(2)}`; } price.textContent = (product.price_varies ? `${this.dataset.from} ` : '') + formatted; a.append(price); grid.append(a);
   }
   this.hidden = !grid.children.length;
  }
  disconnectedCallback() { this.controller?.abort(); }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
